import "../ws8/ws8.css";
import { WatchView } from "../ws8/watch/WatchView";

/** Watch (/watch/:videoId): the clip editor. Owned by WS8 (implementation in web/src/ws8/watch). */
export function WatchPage() {
  return <WatchView />;
}
